import React, {useContext, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip, Typography,} from '@mui/material';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import APIWrapperContext from '../../../services/APIWrapperContext';
import {DocumentsService} from '../../../services/openapi/services/DocumentsService';
import {FolderTreePicker} from './FolderTreePicker';

interface MoveFileProps {
    curr_dir_id: string;
    type: string;
    name: string;
    onMoveStart?: () => void;
    onMoveSuccess?: () => void;
    onMoveError?: () => void;
}

export const MoveFile: React.FC<MoveFileProps> = ({
                                                      curr_dir_id,
                                                      type,
                                                      name,
                                                      onMoveStart,
                                                      onMoveSuccess,
                                                      onMoveError
                                                  }) => {
    const {call_backend_api} = useContext(APIWrapperContext);
    const [open, setOpen] = useState(false);
    const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
    const [selectedFolderName, setSelectedFolderName] = useState<string>('');
    const [selectedFolderPath, setSelectedFolderPath] = useState<string>('');
    const [currentFullPath, setCurrentFullPath] = useState<string>('');

    const handleClickOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedFolderId(null);
        setSelectedFolderName('');
        setSelectedFolderPath('');
    };

    const handleSelectFolder = (folderId: string, folderName: string, folderPath: string, currentFullPath?: string) => {
        setCurrentFullPath(currentFullPath || '');
        setSelectedFolderId(folderId);
        setSelectedFolderName(folderName);
        setSelectedFolderPath(folderPath);
    };

    const handleMove = () => {
        if (!selectedFolderId || !selectedFolderPath) {
            return;
        }

        // Call onMoveStart to trigger optimistic update
        onMoveStart?.();
        handleClose();
        console.log(curr_dir_id, name, selectedFolderId, currentFullPath)
        call_backend_api(
            DocumentsService.moveDocumentDocMovePost(curr_dir_id, name, selectedFolderId, currentFullPath),
            () => {
                onMoveSuccess?.();
            },
            () => {
                onMoveError?.();
            },
            undefined,
            true,
            `${type === 'file' ? 'Datei' : 'Ordner'} verschoben!`,
            `${type === 'file' ? 'Datei' : 'Ordner'} konnte nicht verschoben werden!`
        );
    };

    return (
        <>
            <Tooltip title='Verschieben'>
                <IconButton onClick={handleClickOpen} color='primary' edge='end' aria-label='move'>
                    <DriveFileMoveIcon/>
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth='sm'
                fullWidth
                aria-labelledby='move-dialog-title'
                aria-describedby='move-dialog-description'>
                <DialogTitle id='move-dialog-title'>
                    {type === 'file' ? 'Datei verschieben' : 'Ordner verschieben'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='move-dialog-description' sx={{mb: 2}}>
                        {type === 'file'
                            ? `Wählen Sie den Zielordner für die Datei "${name}"`
                            : `Wählen Sie den Zielordner für den Ordner "${name}"`}
                    </DialogContentText>

                    {selectedFolderId && (
                        <Box sx={{mb: 2, p: 1, bgcolor: 'primary.light', borderRadius: 1}}>
                            <Typography variant='body2' color='primary.contrastText'>
                                Verschieben nach "{currentFullPath}"
                            </Typography>
                        </Box>
                    )}

                    <FolderTreePicker
                        selectedFolderId={selectedFolderId}
                        onSelectFolder={handleSelectFolder}
                        currentFileId={curr_dir_id}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Abbrechen</Button>
                    <Button
                        onClick={handleMove}
                        color='primary'
                        variant='contained'
                        disabled={!selectedFolderId}
                        autoFocus>
                        Verschieben
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
